import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CbDialogModule} from '@app/shared/components/dialog/dialog.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CbInfoMessageModule, CbLoadingSpinnerModule} from 'cb-hub-lib';
import {CbFormsModule} from '@app/shared/components/forms/forms.module';
import {DocumentTemplatesComponent} from './document-templates.component';
import {DocumentTemplateDialogComponent} from './document-template-dialog/document-template-dialog.component';
import {DocumentTemplateHistoryDialogComponent} from './document-template-history-dialog/document-template-history-dialog.component';
import {MatTabsModule} from '@angular/material/tabs';
import {CbDatePipeModule} from '@app/shared/pipe/date/date.module';
import {MatMenuModule} from '@angular/material/menu';
import {MatDividerModule} from '@angular/material/divider';
import {CbDocumentsModule} from '@app/shared/components/documents/documents.module';

@NgModule({
    declarations: [
        DocumentTemplatesComponent,
        DocumentTemplateDialogComponent,
        DocumentTemplateHistoryDialogComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        CbDialogModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatInputModule,
        MatTableModule,
        CbInfoMessageModule,
        CbLoadingSpinnerModule,
        CbFormsModule,
        MatTabsModule,
        CbDatePipeModule,
        MatMenuModule,
        MatDividerModule,
        CbDocumentsModule,
    ],
    exports: [
        DocumentTemplatesComponent
    ]
})
export class DocumentTemplatesModule { }
